const data = [
    {
        id: 14,
        alt: "project",
        image: "images/reactp14.png",
        webUrl: "https://netflixdesi.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/netflixdesi",
    },
    {
        id: 12,
        alt: "project",
        image: "images/reactp12.png",
        webUrl: "https://qrcodegenerater.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/qrcodegenerator",
    },
    {
        id: 13,
        alt: "project",
        image: "images/reactp13.png",
        webUrl: "https://react-urlshortner.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/urlshortner",
    },
    {
        id: 18,
        alt: "project",
        image: "images/reactp18.png",
        webUrl: "https://todo-list-appreact.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/todoappredux",
    },
    {
        id: 17,
        alt: "project",
        image: "images/reactp17.png",
        webUrl: "https://github.com/adarshsharma27/ipaddresstracker",
        gitUrl: "https://ipaddresstracker-react.netlify.app/",
    },
    {
        id: 16,
        alt: "project",
        image: "images/reactp16.png",
        webUrl: "https://react-hackernewsapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/hackernewsapp",
    },
    {
        id: 15,
        alt: "project",
        image: "images/reactp15.png",
        webUrl: "https://netflixdesi.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/devtoclone",
    },
    
    {
        id: 0,
        alt: "project",
        image: "images/reactp1.png",
        webUrl: "https://react-dashboardapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/materialuireact",
    },
    {
        id: 2,
        alt: "project",
        image: "images/reactp2.png",
        webUrl: "https://react-crypto-trackerapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/cryptoapp",
    },
    {
        id: 3,
        alt: "project",
        image: "images/reactp3.png",
        webUrl: "https://react-pixabayapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/pixabayClone",
    },
    {
        id: 4,
        alt: "project",
        image: "images/reactp4.png",
        webUrl: "https://react-dictionaryapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/dictionaryapp",
    },
    {
        id: 5,
        alt: "project",
        image: "images/reactp5.png",
        webUrl: "https://react-movies-ap.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/moviesapp",
    },
    {
        id: 6,
        alt: "project",
        image: "images/reactp6.png",
        webUrl: "https://react-restcountriesapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/reactrestcountries",
    },
    {
        id: 7,
        alt: "project",
        image: "images/reactp7.png",
        webUrl: "https://react-foodap.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/reactfoodapp",
    },
    {
        id: 8,
        alt: "project",
        image: "images/reactp8.png",
        webUrl: "https://react-usergenerator.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/usergenerator",
    },
    {
        id: 9,
        alt: "project",
        image: "images/reactp9.png",
        webUrl: "https://react-mealgenerator.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/mealgenerator",
    },
    {
        id: 10,
        alt: "project",
        image: "images/reactp10.png",
        webUrl: "https://react-tvshowapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/tvshowapp",
    },
    {
        id: 11,
        alt: "project",
        image: "images/reactp11.png",
        webUrl: "https://react-advice-generatorapp.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/advicegenerator",
    },
];

export default data;
